import React from 'react';
import { MobileCalculatorInterface } from '@/components/calculator/MobileCalculatorInterface';
import { CalculatorErrorBoundary } from '@/components/calculator/CalculatorErrorBoundary';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';

const MobileCalculator: React.FC = () => {
  return (
    <ProtectedRoute>
      <CalculatorErrorBoundary>
        <div className="min-h-screen bg-background">
          <MobileCalculatorInterface />
        </div>
      </CalculatorErrorBoundary>
    </ProtectedRoute>
  );
};

export default MobileCalculator;
